(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-amla-selected-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.bwGalleryBound) {
  window.bwGalleryBound = true;
  const prepare = () => document.querySelectorAll('[data-bw-gallery]').forEach(gallery => {
    if (gallery.dataset.bwPrepared) return;
    const stage = gallery.querySelector('.bw-gallery-stage');
    const slides = [...gallery.querySelectorAll('[data-bw-slide]')];
    const buttons = [...gallery.querySelectorAll('[data-bw-select]')];
    const thumbs = gallery.querySelector('.bw-gallery-thumbs');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0, frame = 0, dragFrame = 0, drag = null, suppressClick = false;
    const connection = navigator.connection;
    const constrained = () => connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    const load = (index, priority = 'low') => {
      const slide = slides[index];
      if (!slide) return;
      const template = slide.querySelector('template[data-bw-image]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      const img = slide.querySelector('img');
      if (img) {
        img.decoding = 'async';
        img.fetchPriority = priority;
        img.loading = 'eager';
      }
    };
    const adjacent = index => {
      load(index, 'high');
      if (!constrained()) { load(index - 1); load(index + 1); }
    };
    const select = index => {
      buttons[current]?.setAttribute('aria-pressed', 'false');
      if (slides[current]) slides[current].inert = true;
      current = index;
      buttons[current]?.setAttribute('aria-pressed', 'true');
      if (slides[current]) slides[current].inert = false;
      const button = buttons[index];
      if (button) {
        const left = button.offsetLeft - thumbs.offsetLeft;
        if (left < thumbs.scrollLeft) thumbs.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
        else if (left + button.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth)
          thumbs.scrollTo({ left: left + button.offsetWidth - thumbs.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      adjacent(index);
    };
    const go = index => {
      index = Math.max(0, Math.min(slides.length - 1, index));
      adjacent(index);
      const direct = reduced.matches || Math.abs(index - current) > 1;
      stage.scrollTo({ left: index * stage.clientWidth, behavior: direct ? 'instant' : 'smooth' });
      if (direct) select(index);
    };
    gallery.dataset.bwPrepared = 'true';
    slides.forEach((slide, i) => { slide.hidden = false; slide.inert = i !== 0; });
    buttons.forEach((button, i) => {
      button.addEventListener('pointerenter', () => load(i), { passive: true });
      button.addEventListener('focus', () => load(i));
      button.addEventListener('click', () => go(i));
    });
    stage.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
        if (index !== current) select(index);
      });
    }, { passive: true });
    stage.addEventListener('pointerdown', event => {
      adjacent(current);
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: stage.scrollLeft, id: event.pointerId, moved: false };
      suppressClick = false;
    });
    stage.addEventListener('pointermove', event => {
      if (!drag) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 6) return;
      drag.moved = true;
      stage.dataset.dragging = '';
      stage.setPointerCapture(event.pointerId);
      drag.targetLeft = drag.left - distance;
      if (!dragFrame) dragFrame = requestAnimationFrame(() => {
        dragFrame = 0;
        if (drag) stage.scrollLeft = drag.targetLeft;
      });
    });
    const finishDrag = event => {
      if (!drag) return;
      if (dragFrame) { cancelAnimationFrame(dragFrame); dragFrame = 0; }
      const moved = drag.moved;
      const distance = event.clientX - drag.x;
      const origin = Math.round(drag.left / stage.clientWidth);
      drag = null;
      delete stage.dataset.dragging;
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      if (moved) {
        suppressClick = true;
        go(Math.abs(distance) > 40 ? origin + (distance < 0 ? 1 : -1) : origin);
      }
    };
    stage.addEventListener('pointerup', finishDrag);
    stage.addEventListener('pointercancel', finishDrag);
    stage.addEventListener('dragstart', event => event.preventDefault());
    stage.addEventListener('click', event => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
    }, true);
    gallery.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      go(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let width = stage.clientWidth;
    new ResizeObserver(() => {
      if (stage.clientWidth === width) return;
      width = stage.clientWidth;
      stage.scrollTo({ left: current * width, behavior: 'instant' });
    }).observe(stage);
    const first = slides[0]?.querySelector('img');
    const warm = () => {
      if (constrained()) return;
      const start = () => { if (gallery.isConnected) load(1); };
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
      else setTimeout(start, 250);
    };
    if (first?.complete) warm();
    else first?.addEventListener('load', warm, { once: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-delivery-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-delivery-timeline')) {
  class BWDeliveryTimeline extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.refreshTimer = setInterval(() => this.updateDates(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.refreshTimer);
    }
    addBusinessDays(start, days) {
      const date = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 12);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) added++;
      }
      return date;
    }
    updateDates() {
      const today = new Date();
      const earliest = this.addBusinessDays(today, 5);
      const latest = this.addBusinessDays(today, 7);
      const options = { day: 'numeric', month: 'short' };
      if (latest.getFullYear() !== today.getFullYear()) options.year = 'numeric';
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      this.querySelector('[data-order-date]').textContent = formatter.format(today);
      this.querySelector('[data-delivery-date]').textContent = `${formatter.format(earliest)} – ${formatter.format(latest)}`;
    }
  }
  customElements.define('bw-delivery-timeline', BWDeliveryTimeline);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.bwGalleryBound) {
  window.bwGalleryBound = true;
  const prepare = () => document.querySelectorAll('[data-bw-gallery]').forEach(gallery => {
    if (gallery.dataset.bwPrepared) return;
    const stage = gallery.querySelector('.bw-gallery-stage');
    const slides = [...gallery.querySelectorAll('[data-bw-slide]')];
    const buttons = [...gallery.querySelectorAll('[data-bw-select]')];
    const thumbs = gallery.querySelector('.bw-gallery-thumbs');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0, frame = 0, dragFrame = 0, drag = null, suppressClick = false;
    const connection = navigator.connection;
    const constrained = () => connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    const load = (index, priority = 'low') => {
      const slide = slides[index];
      if (!slide) return;
      const template = slide.querySelector('template[data-bw-image]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      const img = slide.querySelector('img');
      if (img) {
        img.decoding = 'async';
        img.fetchPriority = priority;
        img.loading = 'eager';
      }
    };
    const adjacent = index => {
      load(index, 'high');
      if (!constrained()) { load(index - 1); load(index + 1); }
    };
    const select = index => {
      buttons[current]?.setAttribute('aria-pressed', 'false');
      if (slides[current]) slides[current].inert = true;
      current = index;
      buttons[current]?.setAttribute('aria-pressed', 'true');
      if (slides[current]) slides[current].inert = false;
      const button = buttons[index];
      if (button) {
        const left = button.offsetLeft - thumbs.offsetLeft;
        if (left < thumbs.scrollLeft) thumbs.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
        else if (left + button.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth)
          thumbs.scrollTo({ left: left + button.offsetWidth - thumbs.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      adjacent(index);
    };
    const go = index => {
      index = Math.max(0, Math.min(slides.length - 1, index));
      adjacent(index);
      const direct = reduced.matches || Math.abs(index - current) > 1;
      stage.scrollTo({ left: index * stage.clientWidth, behavior: direct ? 'instant' : 'smooth' });
      if (direct) select(index);
    };
    gallery.dataset.bwPrepared = 'true';
    slides.forEach((slide, i) => { slide.hidden = false; slide.inert = i !== 0; });
    buttons.forEach((button, i) => {
      button.addEventListener('pointerenter', () => load(i), { passive: true });
      button.addEventListener('focus', () => load(i));
      button.addEventListener('click', () => go(i));
    });
    stage.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
        if (index !== current) select(index);
      });
    }, { passive: true });
    stage.addEventListener('pointerdown', event => {
      adjacent(current);
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: stage.scrollLeft, id: event.pointerId, moved: false };
      suppressClick = false;
    });
    stage.addEventListener('pointermove', event => {
      if (!drag) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 6) return;
      drag.moved = true;
      stage.dataset.dragging = '';
      stage.setPointerCapture(event.pointerId);
      drag.targetLeft = drag.left - distance;
      if (!dragFrame) dragFrame = requestAnimationFrame(() => {
        dragFrame = 0;
        if (drag) stage.scrollLeft = drag.targetLeft;
      });
    });
    const finishDrag = event => {
      if (!drag) return;
      if (dragFrame) { cancelAnimationFrame(dragFrame); dragFrame = 0; }
      const moved = drag.moved;
      const distance = event.clientX - drag.x;
      const origin = Math.round(drag.left / stage.clientWidth);
      drag = null;
      delete stage.dataset.dragging;
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      if (moved) {
        suppressClick = true;
        go(Math.abs(distance) > 40 ? origin + (distance < 0 ? 1 : -1) : origin);
      }
    };
    stage.addEventListener('pointerup', finishDrag);
    stage.addEventListener('pointercancel', finishDrag);
    stage.addEventListener('dragstart', event => event.preventDefault());
    stage.addEventListener('click', event => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
    }, true);
    gallery.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      go(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let width = stage.clientWidth;
    new ResizeObserver(() => {
      if (stage.clientWidth === width) return;
      width = stage.clientWidth;
      stage.scrollTo({ left: current * width, behavior: 'instant' });
    }).observe(stage);
    const first = slides[0]?.querySelector('img');
    const warm = () => {
      if (constrained()) return;
      const start = () => { if (gallery.isConnected) load(1); };
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
      else setTimeout(start, 250);
    };
    if (first?.complete) warm();
    else first?.addEventListener('load', warm, { once: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
}
  } catch(e) { console.error(e); }
})();

})();
